import { fallbackLanguage } from '@valk-nx/core/lib/core';

const HOME_URL = /^\/$|(^|\/)home\/?$/;
const HOME_SEGMENT = /(^|\/)home\/?$/;
const TRAILING_SLASH = /\/$/;

export function isHomeUrl(url: string | undefined): boolean {
	return HOME_URL.test(url ?? '');
}

/**
 * Drops the `home` segment while keeping any language prefix, so `en/home`
 * becomes `en` and `home` becomes an empty path that callers append to a host.
 */
export function stripHomeSlug(path: string): string {
	return path.replace(HOME_SEGMENT, '$1').replace(TRAILING_SLASH, '');
}

/**
 * The home story is served from the language root, never from `/home`. It has
 * to resolve to a non-empty path: an empty url reads as "no link" and hides
 * every component that renders its link behind a truthiness check.
 */
export function languageRootUrl(
	language: string,
	rootLanguage: string = fallbackLanguage,
): string {
	const lowerCased = language.toLowerCase();

	return lowerCased === rootLanguage.toLowerCase() ? '/' : `/${lowerCased}`;
}
